import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "navbar navbar-expand-md fixed-top navbar-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarTogglerMenu",
  "aria-controls": "navbarTogglerMenu",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Treebal Pro"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-profile-avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "treebal-users" })
], -1)
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbarTogglerMenu"
}
const _hoisted_7 = { class: "organization-name" }
const _hoisted_8 = { class: "navbar-nav global-menu" }
const _hoisted_9 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_10 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_11 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "navbar-nav global-menu ms-auto" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "navbar-nav ms-auto profile-menu" }
const _hoisted_17 = { class: "nav-item dropdown" }
const _hoisted_18 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownProfile",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_19 = { class: "profile-name" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "profile-avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "treebal-users" })
], -1)
const _hoisted_21 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_27 = { class: "profile-langage" }
const _hoisted_28 = ["value"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_33 = { class: "info" }
const _hoisted_34 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        "aria-current": "page",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userOrganization.name), 1),
        _createElementVNode("ul", _hoisted_8, [
          (_ctx.$can('read', 'Visibility'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  "active-class": "active",
                  class: "nav-link",
                  "aria-current": "page",
                  innerHTML: _ctx.$t('navbar.titles.external'),
                  to: "/externals"
                }, null, 8, ["innerHTML"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.$can('read', 'Pro'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  "active-class": "active",
                  class: "nav-link",
                  "aria-current": "page",
                  innerHTML: _ctx.$t('navbar.titles.internal'),
                  to: "/internals"
                }, null, 8, ["innerHTML"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.canManagePolls)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  "active-class": "active",
                  class: "nav-link",
                  "aria-current": "page",
                  innerHTML: _ctx.$t('navbar.titles.polls'),
                  to: "/polls"
                }, null, 8, ["innerHTML"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              "active-class": "active",
              class: "nav-link",
              "aria-current": "page",
              innerHTML: _ctx.$t('navbar.titles.organization'),
              to: "/organization"
            }, null, 8, ["innerHTML"])
          ])
        ]),
        _createElementVNode("ul", _hoisted_13, [
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("a", {
              href: "https://www.treebal.green/documentation.html",
              target: "_blank",
              class: "nav-link tutos",
              innerHTML: _ctx.$t('navbar.titles.documentation')
            }, null, 8, _hoisted_15)
          ])
        ]),
        _createElementVNode("ul", _hoisted_16, [
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("a", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.userProfile.name), 1),
              _hoisted_20
            ]),
            _createElementVNode("ul", _hoisted_21, [
              (_ctx.isDatasForStats)
                ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: "/stats",
                      innerHTML: _ctx.$t('navbar.titles.kpi')
                    }, null, 8, _hoisted_23)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isRootAdmin)
                ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToConfiguration())),
                      innerHTML: _ctx.$t('navbar.titles.configuration')
                    }, null, 8, _hoisted_25)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_26,
              _createElementVNode("li", _hoisted_27, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("navbar.profile.langage")), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$i18n.locale) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: `locale-${locale}`,
                      value: locale
                    }, _toDisplayString(locale), 9, _hoisted_28))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.$i18n.locale]
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.profile())),
                  innerHTML: _ctx.$t('navbar.profile.my_account')
                }, null, 8, _hoisted_29)
              ]),
              _hoisted_30,
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout())),
                  innerHTML: _ctx.$t('navbar.profile.logout')
                }, null, 8, _hoisted_31)
              ]),
              _hoisted_32,
              _createElementVNode("li", _hoisted_33, _toDisplayString(_ctx.$t("navbar.profile.smsCredits")) + " " + _toDisplayString(_ctx.smsCredits), 1),
              _createElementVNode("li", _hoisted_34, _toDisplayString(_ctx.appVersion), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}